<template>
    <div>
        <v-card class="">
            <person-assets-table :person-id="personId" />
        </v-card>
    </div>
</template>

<script>
    import PersonAssetsTable from './PersonAssetsTable';

    export default {

        name: "PersonAsset",

        components: {
            PersonAssetsTable
        },

        props: {
            personId: {
                type: Number,
                required: true,
            },
        },

        data: function () {
            return {
                panel: [true]
            }
        },
        mounted() {
        },
    }
</script>

<style scoped>
    #personAssets {
        font-size: 14px;
    }

    .personVehicleTable {
        width: 100%;
        text-align: left;
        padding-left: 16px;
    }
</style>
